// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { keyframes } from 'styled-components';

import { NotFound1 } from '../../assets/img';
import { Target } from '../../client';
import useRouter from '../../hooks/useRouter';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import RoundedButton from '../RoundedButton';

const SPACING = 0.7;

const haloAnimation = keyframes`
  0% {
    box-shadow: 0px 0px 0em 0em #b20e1087;
  }

  50% {
    box-shadow: 0px 0px 1em 0.2em #b20e1087;
  }

  100% {
    box-shadow: 0px 0px 0em 0em #b20e1087;
  }
`;

const Wrapper = styled.div`
  margin-top: ${Target.__MOBILE__ ? undefined : '8em'};
  padding-top: 1em;
  height: ${Target.__MOBILE__ ? 'calc(100vh - 6.5em)' : undefined};
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-weight: bold;

  overflow: hidden;
`;

const IconWrapper = styled.div`
  border-radius: 50%;
  margin-bottom: ${SPACING}em;
  border: 0.3em solid ${theme.NotFoundView.Icon.borderColor};
  font-size: 1em;
  animation: ${haloAnimation} 3000ms ease-in-out infinite;
`;

const Icon = styled.div`
  height: 10em;
  width: 10em;
  background-image: ${({ $imgPath }) => `url(${$imgPath})`};
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  background-position: 50% 0%;
  border: 0.35em solid black;
`;

const Label = styled.div`
  color: ${theme.NotFoundView.Label.color};
  margin-bottom: ${SPACING}em;
  font-size: 1.2em;
  padding: 0em 2em;
  text-align: center;

  &:first-letter {
    text-transform: uppercase;
  }
`;
const SubLabel = styled.div`
  color: ${theme.NotFoundView.SubLabel.color};
  margin-bottom: ${SPACING}em;
  font-size: 1em;
  padding: 0em 2em;
  text-align: center;
`;

const TopMatchButton = styled(RoundedButton)`
  padding: 0em 3.5em;
  font-size: 1em;
`;

type NotFoundViewProps = {
  label: string;
  imgPath?: string | null;
  hideButton?: boolean | null;
  className?: string;
  subLabel?: string;
};

const NotFoundView = ({ imgPath = NotFound1, label, subLabel, hideButton = false, className }: NotFoundViewProps) => {
  const { history } = useRouter();

  const onTopMatchButtonClick = useCallback(() => {
    history.push(RoutesRedirectionFactory.getHomeRouteConfig());
  }, [history]);

  return (
    <Wrapper className={className}>
      {imgPath ? (
        <IconWrapper className="icon-wrapper">
          <Icon className="icon" $imgPath={imgPath} />
        </IconWrapper>
      ) : null}
      <Label className="label">{label}</Label>
      {subLabel ? <SubLabel className="sub-label">{subLabel}</SubLabel> : null}
      {!hideButton ? (
        <TopMatchButton
          backgroundColor={theme.NotFoundView.TopMatchButton.backgroundColor}
          color={theme.NotFoundView.TopMatchButton.color}
          label={__('See top matches')}
          onClick={onTopMatchButtonClick}
        />
      ) : null}
    </Wrapper>
  );
};

export default NotFoundView;
